import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Histologia from './containers/histologia';
import Citologia from './containers/citologia';
import Imunologia from './containers/imunologia';
import Arquivamento from './containers/arquivamento';
import * as organizarActions from './store/organizar.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import { rotaEnum } from '@common/util/defaultValues';
import IntlMessage from "../../../helpers/intlMessage";

export default function ModalMoverLote(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const [click, setClick] = useState(false);
  const [page, setPage] = useState('');
  const [componentItem, setcomponentItem] = useState();
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;

  const organizarLote = useSelector(state => state.organizarLote);
  const location = useLocation();

  useEffect(() => {
    setcomponentItem(location.pathname.replace('/', ''));
  }, [location]);

  useEffect(() => {
    setModalAberto(organizarLote.modal);
  }, [organizarLote.modal]);

  const dispatch = useDispatch();

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(organizarActions.atualizarModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  useEffect(() => {
    if (props.showModal) {
      setModalAberto(props.showModal);
      dispatch(organizarActions.atualizarModal(props.showModal))
      setClick(false);
      // Histologia Inclusão
      if (Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id) {
        setPage('Histologia Inclusão');
      } else if (Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id) {
        setPage('Histologia Lâminas');
      } else if (Object.entries(props.lista[1])[1][1].text === "Concluídos") {
        setPage('Requisição de Materiais');
      }
      else {
        setPage(componentItem);
      }
    }
  }, [props.showModal]);

  return (
    <Modal
      className="mv-modal-kanban"
      backdrop={backdrop}
      keyboard={keyboard}
      centered
      isOpen={modalAberto}
      toggle={toggle}
    >
      <ModalHeader toggle={!props.close ? toggle : props.close}>
        <IntlMessage id = "dashboards.cytology.organizeLot"/>
      </ModalHeader>
      <ModalBody>
        {(() => {
          switch (componentItem) {
            case rotaEnum.HISTOLOGIA:
              return <Histologia {...props} click={click} />;
            case rotaEnum.CITOLOGIA:
              return <Citologia {...props} click={click} />;
            case rotaEnum.IMUNOLOGIA:
              return <Imunologia {...props} click={click} />;
            case rotaEnum.ARQUIVAMENTO:
              return <Arquivamento {...props} click={click} onClick={() => setClick(false)} />;
            default:
              return null;
          }
        })()}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={!props.cancelar ? toggle : props.cancelar}
          className={`button-cancel`}
          color="secondary"
        >
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button
          className={`button-confirm`}
          onClick={(e) => {
            setClick(true);
          }}
          disabled={organizarLote.moverDisabled}
          color="primary"
        >
          <IntlMessage id = "general.materialArchiving.toMove"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/modal.js